import { defineStore } from 'pinia';
import { fetchBuildings } from '@/api';

export default defineStore({
  id: 'buildings',

  state: () => {
    return {
      buildings: [],
      activeBuildingId: null,
      activeBuildingStats: {},
    };
  },

  getters: {},

  actions: {
    async load(accountId) {
      this.buildings = await fetchBuildings(accountId);
      this.setActiveBuilding(this.buildings[0]);
    },

    setActiveBuilding(building) {
      this.activeBuildingId = building.buildingId;
      this.activeBuildingStats = building.stats;

      // Computed properties for display purposes
      this.activeBuildingStats.totalOfflineAndUnknown =
        building.stats.totalOfflines + building.stats.totalUnknowns;
      this.activeBuildingStats.totalDevices =
        building.stats.totalOfflines +
        building.stats.totalOnlines +
        building.stats.totalUnknowns;
    },
  },
});
